import Vue from 'vue';
// The order is crucial here, don't move this line below.
// Otherwise you will get "[vue-composition-api] must call Vue.use(VueCompositionAPI) before using any function." error
import './plugins/composition-api';
import VueMeta from 'vue-meta';

import { AppServerError } from './types';

import App from './App.vue';
import router from './router';

import DIPlugin from './di/plugin';
import EventEventBusPlugin from './plugins/EventBus';
import ToastPlugin from './plugins/toast/toast';
import ConfirmPlugin from './plugins/confirm';

import './plugins/validation';

import client from './core/client';

import { errorToMessage } from './util';

import './styles/slds.scss';
import './styles/tailwind.css';
import './styles/index.scss';

Vue.config.productionTip = false;

Vue.use(VueMeta);

Vue.use(EventEventBusPlugin);
Vue.use(ToastPlugin);

Vue.use(DIPlugin);
Vue.use(ConfirmPlugin);

new Vue({
  router,
  created() {
    client.interceptors.response.use(
      (res) => res,
      (e: AppServerError) => {
        const { response } = e;
        if (response === undefined) {
          throw e;
        }

        const AUTH_ME_URL = '/apis/auth/me';

        if (response.config.url === AUTH_ME_URL && response.status === 403) {
          return;
        }

        this.$toast(errorToMessage(e));

        throw e;
      }
    );
  },
  render: (h) => h(App),
}).$mount('#app');
